const projects = [
  {
    name: "Axis AI College Compendium",
    tech: "Java, Python, Angular, Spring Boot Maven, PostgreSQL, AWS S3, TypeScript, Claude",
    date: "January 2025 - May 2025",
    desc: [
      "Built an AI-powered college compendium platform with 5,000+ colleges and 30,000+ scholarships that has an AI essay feedback & document storage system with a Java Spring Boot Maven backend and an Angular frontend, helping high school students navigate post-secondary options",
    ],
    images: [],
    github: "https://github.com/acm-projects/Axis",
  },
  {
    name: "Speechability",
    tech: "Python",
    date: "January 2024 - May 2024",
    desc: [
      "Improved voice command execution accuracy by ~24% by optimizing a recognition module with custom command matching logic with Python in an agile development environment",
      "Reduced latency by up to 3 seconds per interaction by implementing background noise mitigation in Python, enhancing overall app responsiveness and user experience",
    ],
    images: [],
    github: "",
  },
  {
    name: "SEOptimize",
    tech: "Python, JavaScript, Next.js, AWS Services, Docker, OpenAI API, FastAPI",
    date: "August 2024 - October 2024",
    desc: [
      "Created an AI-powered SaaS web app that generates SEO-optimized business content using OpenAI and deployed backend serverlessly via AWS Lambda & API Gateway in Python & JavaScript, all containerized using Docker, improving responsiveness",
    ],
    images: ["/media/SaasApp.png"],
    link: "https://ai-saas-app-swart.vercel.app/",
    github: "https://github.com/kphilippp/AI_Saas_App",
  },
  {
    name: "ClientConnect",
    tech: "JavaScript, Vue.js, PostgreSQL",
    date: "August 2022 - May 2023",
    desc: [
      "Streamlined assistance to 4,000+ clients by building customer-tailored pages and constructing API endpoints on Vue.js framework in JavaScript, which performed CRUD operations on a PostgreSQL database",
      "Increased client satisfaction by leading 5 collaborative sessions with the front-end team and the client to assess requirements and receive feedback on iterative designs, helping developers create a better product",
    ],
    images: [],
    github: "",
  },
  {
    name: "ABImports Website",
    tech: "React, JavaScript, HTML/CSS, Express, AWS S3, MySQL",
    date: "August 2022 - May 2023",
    desc: [
      "Increased productivity for a local car importer by building a full-stack React web application with efficient state management, RESTful API integration, and smart data management using MySQL and AWS S3",
    ],
    images: [
      "/media/abimports.png",
      "/media/abimports2.png",
      "/media/abimports3.png",
      "/media/abimports4.png",
      "/media/abimports5.png",
      "/media/abimports6.png",
    ],
    github: "https://github.com/kphilippp/ABimportsWebsite",
  },
];

export default projects;
